import remove from 'lodash/remove';
import typeToReducer from 'type-to-reducer';
import { ModalState } from '../types';
import { OPEN_MODAL, CLOSE_MODAL } from '../constants';

const initialState: ModalState = {
  openModals: [],
};

export default typeToReducer(
  {
    [OPEN_MODAL]: (state, { payload }) => ({
      ...state,
      openModals: state.openModals.concat([payload]),
    }),
    [CLOSE_MODAL]: (state, { payload }) => ({
      ...state,
      openModals: remove(state.openModals, payload),
    }),
  },
  initialState
);
